import type { RootState } from 'state';
import type { FlightCalendarsFiltersState } from '../slice';

function getFiltersValues(state: RootState): FlightCalendarsFiltersState {
  return state.flightCalendars.filtersValues;
}

export default getFiltersValues;
